import { POST_RX_DISCOUNT_URL, RXValues } from "@src/site/types";
import React, { useState, useEffect } from "react";
import { useCart } from "./CartProvider";
import { HandleAxios } from "@shared_components/components/requests/HandleAxios";
import { TooltipElement } from "@shared_components/components/Tooltip";


export const RxDiscountHandler = () => {
    const [discountCode, setDiscountCode] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const { values, setValues, handleSetValues } = useCart();

    const handleVerifyDiscountCode = () => {
        const handleComplete = (response: any) => {
            if (response && response?.data && response?.data?.data){
                handleSetValues({
                    ...values,
                    discountCode: discountCode,
                    discountAmount: response.data.data
                });
                setTimeout(() => {
                    setSuccess(null);
                }
                , 5000);
                setSuccess("Discount code applied successfully!");
                setError(null);
            }
            setLoading(false);
        }
        const onError = (error: any) => {
            console.error("Error verifying discount code:", error);
            setLoading(false);
            setError(typeof error === "string" ? error : "An error occurred while verifying the discount code.");
        }
        setSuccess(null);
        setLoading(true);
        HandleAxios({
            url: POST_RX_DISCOUNT_URL,
            method: "post",
            data: { discount_code: discountCode },
            onComplete: handleComplete,
            onError: onError,
        })
    };


    return (
        <div className="flex flex-col w-full h-full">
            <div className="flex flex-col sm:flex-row items-start sm:items-end gap-3 pt-4 border-t border-gray-200 mt-6">
                <div className="flex-grow w-full sm:w-auto">
                    <div className="flex items-center mb-1 gap-1">
                        <label htmlFor="discount_code" className="block text-sm font-medium text-gray-700">Discount Code</label>
                        <TooltipElement text="If you are part of team program, you can get your teams discount code from teams site. Apply it here to receive your team discount" />
                    </div>
                    <input
                        type="text"
                        name="discount_code"
                        id="discount_code"
                        value={discountCode}
                        onChange={(e) => setDiscountCode(e.target.value)}
                        className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>
                <button
                    type="button"
                    onClick={handleVerifyDiscountCode}
                    disabled={discountCode === "" || loading}
                    className="w-full sm:w-auto px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 disabled:bg-gray-300" /* Example class */
                >
                    {loading ? "Verifying..." : "Verify Discount Code"}
                </button>



            </div>
            <div className="flex items-center">
                {success && (
                    <p className="text-green-500 text-sm mt-2 break-all">{success}</p>
                )}
            </div>
            <div className="flex items-center">
                {error && (
                    <p className="text-red-500 text-sm mt-2 break-all">{error}</p>
                )}
            </div>
        </div>
    );
}